module.exports = __webpack_public_path__ + "static/media/notes.1894c60d.png";